export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL_FOR_IMAGE = `${BASE_URL}/`;
export const GOOGLE_MAP_API_KEY = "AIzaSyBB3zZSGu-LoGY3zwVe59ZFVdzJzAwqp60";
export const APP_SOURCE_NAME = "website";
export const TECHNICIANS_PER_PAGE = 25;
export const CONSUMER_PER_PAGE = 25;
